// Headless component that keeps InsightFlare's identity in sync with the
// logged-in user. Must be rendered inside <InsightFlareProvider>.
import { useAutoIdentifyUser } from '@/hooks/useAutoIdentifyUser';

export const InsightFlareIdentity = () => {
  useAutoIdentifyUser();
  return null;
};

export default InsightFlareIdentity;
